export function cleanString(value: unknown): string {
  if (value == null) return '';
  const text = String(value)
    .replace(/\u0000/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (text.toUpperCase() === 'NULL') return '';
  return text;
}

export function normalizeLocation(value: unknown): string {
  return cleanString(value)
    .replace(/\s*,\s*/g, ', ')
    .replace(/\s*-\s*/g, ' - ');
}

export function parseNumber(value: unknown): number | null {
  if (value == null) return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const text = cleanString(value);
  if (!text) return null;
  const normalized = text.replace(/,/g, '.').replace(/[^0-9.-]+/g, '');
  if (!normalized || normalized === '.' || normalized === '-') return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function parseLatencyMs(value: unknown): number | null {
  const text = cleanString(value);
  if (!text) return null;
  const match = text.match(/(-?\d+(?:[.,]\d+)?)/);
  if (!match) return null;
  return Number(match[1].replace(',', '.'));
}

export function parseCapacityMbps(value: unknown): number | null {
  const text = cleanString(value);
  if (!text) return null;
  const match = text.match(/(\d+(?:[.,]\d+)?)\s*(K|M|G|T)?b?/i);
  if (!match) return parseNumber(value);
  const num = Number(match[1].replace(',', '.'));
  const unit = (match[2] || 'M').toUpperCase();
  if (!Number.isFinite(num)) return null;
  if (unit === 'K') return num / 1000;
  if (unit === 'M') return num;
  if (unit === 'G') return num * 1000;
  if (unit === 'T') return num * 1000 * 1000;
  return num;
}

export function uniq<T>(arr: T[]) {
  return Array.from(new Set(arr));
}
